<div
  class="sticky group-[.custom-theme]/body:bg-[image:--theme-gradient] bg-[--color-background-navigation] top-0 left-0 z-50 h-16 w-full xl:bg-none shadow-[0_1px_3px_1px_rgba(0,0,0,0.15)]"
  [ngClass]="{ 'backdrop-blur-sm shadow-none border-b': brandService.isChmobile() }"
>
  <div
    class="absolute w-full h-full px-2 xl:px-3 flex rounded-none"
    [ngClass]="{
      'h-screen overflow-hidden flex flex-col justify-between group-[.custom-theme]/body:bg-[image:--theme-gradient] bg-[--color-background-primary]':
        open,
      'bg-[--color-primary-default]': !open && scrolled,
      'xl:bg-[--color-primary-default]': !open && !scrolled,
    }"
  >
    <div class="flex flex-nowrap justify-between items-center xl:container w-full">
      <!-- Logo -->
      <div class="flex flex-1 h-full">
        <lib-link
          [link]="{ link_type: LinkType.Web, url: logoUrl() }"
          [title]="['logoLink'] | translate"
          [ngClass]="{ 'mr-[1rem]': !!logo }"
        >
          @if (logo) {
            <div class="h-full">
              <img [src]="logo.url" [alt]="logo.alt" class="w-full h-full" />
            </div>
          } @else {
            <lib-svg
              svg="brand/logo"
              class="[&_svg]:h-16 [&_svg]:w-20"
              [ngClass]="{
                '[&_svg]:w-24 [&_svg]:md:w-32': !brandService.isYallo(),
                'group-[.custom-theme]/body:[&_svg_path]:fill-white [&_svg_path]:fill-[--color-primary-logo]':
                  !brandService.isChmobile(),
              }"
            ></lib-svg>
          }
        </lib-link>
        <a href="#" class="text-white sr-only focus:not-sr-only" (click)="skipNav($event)">
          {{ ['skipNav'] | translate }}
        </a>
      </div>

      <!-- Desktop navbar -->
      <div #navbar class="mr-4 justify-center items-center hidden xl:flex gap-8" id="navbar">
        @for (item of menuItems; track item; let i = $index) {
          @if (isMenuItemWithDropdown(item); as itemWithDropdown) {
            <lib-menu
              class="relative"
              [ngClass]="{
                'xl:text-xl': brandService.isLebara(),
              }"
              [lightTheme]="true"
              [buttonClass]="
                '[&.mdc-button]:border [&.mdc-button]:border-solid [&.mdc-button]:border-[--color-border-navbar-item] [&.mdc-button]:bg-[--color-background-navigation-button]'
              "
              [textClass]="'!text-[--color-text-navigation]'"
              [arrowIconClass]="'!fill-[--color-text-navigation]'"
              [label]="itemWithDropdown.title"
            >
              @for (subItem of itemWithDropdown.secondLevelEntries; track subItem) {
                <lib-menu-item [menuItemLink]="getSubItemLink(subItem)">
                  <span class="font-bold text-[--color-text-navigation]" (click)="onSubItemClick(item, subItem)">{{
                    subItem.title
                  }}</span>
                </lib-menu-item>
              }
            </lib-menu>
          }
          @if (isSimpleMenuItem(item); as simpleItem) {
            <lib-link
              [link]="simpleItem.link"
              (onClick)="onSubItemClick(simpleItem, null)"
              class="focus:outline-none border border-[--color-border-navbar-item] rounded-full h-12 w-12 sm:w-auto sm:whitespace-nowrap sm:px-3 flex justify-center items-center hover:bg-[--color-background-navigation-hover] bg-[--color-background-navigation-button]"
            >
              <span
                class="group-[.custom-theme]/body:text-[--basic-white] text-[--color-text-navigation] font-bold"
                [ngClass]="{
                  '2xl:text-xl': brandService.isYallo(),
                  'xl:text-xl': !brandService.isYallo(),
                }"
              >
                {{ simpleItem.title }}
              </span>
            </lib-link>
          }
        }
      </div>

      <!-- Right actions -->
      <div class="flex flex-1 justify-end gap-1 xxs:gap-2 xs:gap-4">
        @if (phone?.phoneNumberLink && phone?.phoneNumber) {
          <div
            class="border border-[--color-border-primary] rounded-full h-12 w-12 sm:w-auto sm:whitespace-nowrap sm:px-3 flex justify-center items-center hover:bg-[--color-background-navigation-hover] bg-[--color-background-navigation-button]"
            [class]="phone?.phoneCallPrice ? 'w-auto px-1 xxs:px-2' : 'w-12'"
          >
            <lib-link [link]="phone.phoneNumberLink" class="flex items-center" [ariaLabel]="ariaLabel">
              <div class="sm:flex sm:items-center sm:justify-evenly">
                <lib-svg
                  class="group-[.custom-theme]/body:fill-[--basic-white] fill-[--color-text-navigation] normal-plus sm:mr-3"
                  svg="fontawesome/phone"
                />
                <div class="hidden sm:block">
                  <p
                    class="group-[.custom-theme]/body:text-[--basic-white] text-[--color-text-navigation] font-bold text-xs xl:text-base"
                  >
                    {{ phone.phoneNumber }}
                  </p>
                  @if (phone?.phoneCallPrice) {
                    <p
                      class="group-[.custom-theme]/body:text-[--basic-white] text-[--color-text-navigation] text-xs xl:text-sm text-center"
                    >
                      {{ phone.phoneCallPrice }}
                    </p>
                  }
                </div>
              </div>
            </lib-link>
          </div>
        }
        <lib-language-selector
          [lightTheme]="true"
          [collapseOnMobile]="true"
          buttonClass="[&.mdc-button]:bg-[--color-background-navigation-button]"
          textClass="!text-[--color-text-navigation]"
        ></lib-language-selector>
        <lib-dropdown-menu [lightTheme]="true" [collapseOnMobile]="true"></lib-dropdown-menu>
        @if (menuItems?.length > 0) {
          <button
            data-testid="nav-mobile-hamburger-menu"
            (click)="toggleNav()"
            class="border border-[--color-border-primary] rounded-full h-12 w-12 flex justify-center items-center xl:hidden hover:bg-[--color-background-navigation-hover] bg-[--color-background-navigation-button]"
          >
            <lib-svg
              class="group-[.custom-theme]/body:[&_svg_path]:fill-white [&_svg_path]:fill-[--color-text-navigation] medium"
              [svg]="open ? 'nav-close' : 'nav-burger'"
            ></lib-svg>
          </button>
        }
      </div>
    </div>

    <!-- Mobile dropdown -->
    @if (open) {
      <div #navbar class="flex flex-col justify-center items-center xl:hidden">
        @for (item of menuItems; track item; let i = $index) {
          <div
            class="my-4 flex justify-center group-[.custom-theme]/body:text-[--basic-white] text-[--color-text-navigation] text-center"
          >
            @if (isMenuItemWithDropdown(item); as itemWithDropdown) {
              <div class="flex flex-col justify-center items-center">
                <button
                  (click)="selectDropdown(i, itemWithDropdown)"
                  class="flex justify-center items-center"
                  [attr.aria-expanded]="isDropdownSelected(i)"
                  [attr.data-testid]="'nav-menu-' + generateTestIdName(itemWithDropdown.title)"
                >
                  <p class="inline-block text-2xl font-bold text-center relative">
                    {{ itemWithDropdown.title }}
                  </p>
                  <lib-svg
                    svg="fontawesome/chevron-down"
                    class="ml-2 group-[.custom-theme]/body:fill-[--basic-white] fill-[--color-text-navigation] transition-transform duration-200"
                    [ngClass]="{ 'rotate-180': isDropdownSelected(i) }"
                  ></lib-svg>
                </button>
                <ul [ngClass]="{ hidden: selectedDropdown !== i }" class="flex flex-col items-center">
                  @if (itemWithDropdown.product) {
                    <div class="flex justify-center mt-2">
                      <lib-product-box
                        class="w-[384px]"
                        [productItem]="itemWithDropdown.product"
                        [lightMode]="true"
                        [isNavProduct]="true"
                      ></lib-product-box>
                    </div>
                  }
                  @for (subItem of itemWithDropdown.secondLevelEntries; track subItem) {
                    <li class="mt-3">
                      <lib-link
                        [attr.data-testid]="'nav-submenu-' + generateTestIdName(subItem.title)"
                        [link]="subItem.link"
                        (onClick)="onSubItemClick(itemWithDropdown, subItem)"
                        class="hover:underline"
                      >
                        {{ subItem.title }}
                      </lib-link>
                    </li>
                  }
                </ul>
              </div>
            }
            @if (isSimpleMenuItem(item); as simpleItem) {
              <lib-link [link]="simpleItem.link" (onClick)="onSubItemClick(simpleItem, null)">
                <p class="text-2xl font-bold flex justify-center items-center relative">
                  {{ simpleItem.title }}
                </p>
              </lib-link>
            }
          </div>
        }
      </div>
      <div class="flex justify-center px-8 pb-24">
        @for (lang of languageService.langs; track lang) {
          <p
            class="text-base font-bold text-[--color-nav] mx-2 relative"
            [ngClass]="{
              'after:content-[\'\'] after:block after:absolute after:w-full after:h-[1px] after:bg-[--basic-white] after:bottom-0':
                lang === languageService.current,
            }"
          >
            <lib-link [link]="getLink(lang)" queryParamsHandling="preserve" [translate]="lang"></lib-link>
          </p>
        }
      </div>
    }
  </div>
</div>
